import { useTheme, Stack } from 'src/viewLayer/components/DesignSystem';
import TextWithInterpolation from 'src/viewLayer/components/shared/TextWithInterpolation';
import { t } from 'src/viewLayer/helpers/translations';
import { getImageComponent } from 'src/viewLayer/assets/images';
import type { CourseItemType, ItemCardFeatureIndex } from '../../types';
import './index.scss';
import {
  CourseInfoTitle,
  CourseInfoItem,
  ImageContainer,
  InfoItemsWrapper
} from './index.styled';
import itemCardFeatures from './itemCardFeatures';

export default ({ courses, id } : { courses: CourseItemType[]; id: string; }): JSX.Element => {
  const theme = useTheme();

  return (
    <Stack className="courses-info-container" id={id} alignItems="center">
      <InfoItemsWrapper>
        {courses.map((courseItem: CourseItemType, index: number) => {
          const itemCardIndex = `${courseItem.id}_${courseItem.version}`;
          const {
            backgroundColor,
            width,
            height,
            cardPositionBottom,
            cardPositionRight,
            imagePositionBottom,
            imagePositionRight
          } = itemCardFeatures(theme)[itemCardIndex as ItemCardFeatureIndex];
          return (
            <CourseInfoItem
              key={itemCardIndex}
              id={`uat-course-item-${index}`}
              cardId={courseItem.id}
              cardImage={courseItem.image}
              cardColor={backgroundColor}
              cardWidth={width}
              cardHeight={height}
              cardPositionFromBottom={cardPositionBottom}
              cardPositionFromRight={cardPositionRight}
            >
              <CourseInfoTitle weight="strong" size="xsmall">
                {TextWithInterpolation({ translationText: t(courseItem.title) })}
              </CourseInfoTitle>
              <ImageContainer positionFromBottom={imagePositionBottom} positionFromRight={imagePositionRight}>
                {getImageComponent(courseItem.image)}
              </ImageContainer>
            </CourseInfoItem>
          );
        })}
      </InfoItemsWrapper>
    </Stack>
  );
};
